import { render, staticRenderFns } from "./UpdateClientDoc.vue?vue&type=template&id=56f96ee7"
import script from "./UpdateClientDoc.vue?vue&type=script&lang=js"
export * from "./UpdateClientDoc.vue?vue&type=script&lang=js"
import style0 from "./UpdateClientDoc.vue?vue&type=style&index=0&id=56f96ee7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports